import { Button } from '@chakra-ui/react';

import { LoginCredentials } from '../../api/types';

import schema from './schema';

import { Link } from '@/components/common/Link';
import { FieldWrapper, Form, TextInput } from '@/components/Form';
import * as LC from '@/components/LC';
import { useAuth } from '@/lib/authentication';

type LoginFormProps = {
  onSuccess: () => void;
  onError: (message: string) => void;
};

export const LoginForm = ({ onSuccess, onError }: LoginFormProps) => {
  const { login, isLoggingIn } = useAuth();

  return (
    <Form<LoginCredentials>
      initialValues={{
        email: '',
        password: '',
      }}
      onSubmit={async (values) => {
        try {
          await login(values);
          onSuccess();
        } catch (err: any) {
          onError(err.response.data.error);
        }
      }}
      validationSchema={schema}
    >
      {() => (
        <LC.Vertical w="100%">
          <FieldWrapper
            name="email"
            required
            label="Email"
            as={(props) => <TextInput type="email" {...props} />}
          />
          <FieldWrapper
            name="password"
            required
            label="Senha"
            as={(props) => <TextInput type="password" {...props} />}
          />

          <LC.Vertical center spaceBetween gap="2">
            <Button
              isLoading={isLoggingIn}
              type="submit"
              className="w-full"
              variant="@primary"
              w="100%"
            >
              Login
            </Button>
            <Button as={Link} to="/recuperacao-de-senha" variant="ghost" size="sm" color="#5BA699">
              Esqueci minha senha
            </Button>
          </LC.Vertical>
        </LC.Vertical>
      )}
    </Form>
  );
};
